export default {
  items: [
    "Anglican Church of Australia",
    "Baha'i",
    "Baptist",
    "Buddhism",
    "Chinese religions",
    "Christadelphians",
    "Churches of Christ (Conference)",
    "Coptic Orthodox Church",
    "Greek Orthodox",
    "Hinduism",
    "Islam",
    "Jainism",
    "Japanese religions",
    "Judaism",
    "Lutheran",
    "No religion",
    "Other Protestant",
    "Paganism",
    "Presbyterian",
    "Russian Orthodox",
    "Sikhism",
    "Uniting Church",
    "Western Catholic",
    "Zoroastrianism"
  ]
};



// WEBPACK FOOTER //
// ../data/wa/religion.js